<template>
  <vs-row>
    <vs-col class="p-5" vs-type="flex" vs-w="11" vs-xs="11" vs-sm="5">
      <div>
        <vs-select
          class="selectExample"
          label="Choose Division"
          v-model="division"
          @input="loadLeagueAnalytics"
        >
          <vs-select-item
            :key="d.id"
            :value="d.id"
            :text="d.name"
            v-for="d in divisions"
          />
        </vs-select>
      </div>
    </vs-col>
    <vs-col class="p-5" vs-type="flex" vs-w="11" vs-xs="11" vs-sm="5" vs-lg="6">
      <vx-card class="p-3">
        <h3>Points</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.points">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ p.points }} Points
            </router-link>
          </li>
        </ul>
      </vx-card>
      <vx-card class="p-3">
        <h3>Rebounds</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.rebounds">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ p.rebounds }} Rebounds
            </router-link>
          </li>
        </ul>
      </vx-card>
    </vs-col>
    <vs-col class="p-5" vs-type="flex" vs-w="11" vs-xs="11" vs-sm="5" vs-lg="6">
      <vx-card class="p-3">
        <h3>Assists</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.assists">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ p.assists }} Assists
            </router-link>
          </li>
        </ul>
      </vx-card>
      <vx-card class="p-3">
        <h3>Steals</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.steals">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ p.steals }} Steals
            </router-link>
          </li>
        </ul>
      </vx-card>
    </vs-col>
    <vs-col class="p-5" vs-type="flex" vs-w="11" vs-xs="11" vs-sm="5" vs-lg="6">
      <vx-card class="p-3">
        <h3>2PT Field Goals</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.fgm">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ p.fgm }} FGM
            </router-link>
          </li>
        </ul>
      </vx-card>
      <vx-card class="p-3">
        <h3>3PT Field Goals</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.fgm3">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ p.fgm3 }} FGM3
            </router-link>
          </li>
        </ul>
      </vx-card>
    </vs-col>
    <vs-col class="p-5" vs-type="flex" vs-w="11" vs-xs="11" vs-sm="5" vs-lg="6">
      <vx-card class="p-3">
        <h3>Blocks</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.blocks">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ p.blocks }} Blocks
            </router-link>
          </li>
        </ul>
      </vx-card>
      <vx-card class="p-3">
        <h3>Free Throws</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.ftm">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ p.ftm }} FTM
            </router-link>
          </li>
        </ul>
      </vx-card>
    </vs-col>
    <vs-col class="p-5" vs-type="flex" vs-w="11" vs-xs="11" vs-sm="5" vs-lg="6">
      <vx-card class="p-3">
        <h3>Total Points</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.pointsSum">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ p.points }} Total Points
            </router-link>
          </li>
        </ul>
      </vx-card>
      <vx-card class="p-3">
        <h3>Total Rebounds</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.reboundsSum">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ p.rebounds }} Total Rebounds
            </router-link>
          </li>
        </ul>
      </vx-card>
    </vs-col>
    <vs-col class="p-5" vs-type="flex" vs-w="11" vs-xs="11" vs-sm="5" vs-lg="6">
      <vx-card class="p-3">
        <h3>Total Assists</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.assistsSum">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ p.assists }} Total Assists
            </router-link>
          </li>
        </ul>
      </vx-card>
      <vx-card class="p-3">
        <h3>Total Steals</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.stealsSum">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ p.steals }} Total Steals
            </router-link>
          </li>
        </ul>
      </vx-card>
    </vs-col>
    <vs-col class="p-5" vs-type="flex" vs-w="11" vs-xs="11" vs-sm="5" vs-lg="6">
      <vx-card class="p-3">
        <h3>Total 2PT Field Goals</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.fgmSum">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ p.fgm }} Total FGM
            </router-link>
          </li>
        </ul>
      </vx-card>
      <vx-card class="p-3">
        <h3>Totals 3PT Field Goals</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.fgm3Sum">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ p.fgm3 }} Total FGM3
            </router-link>
          </li>
        </ul>
      </vx-card>
    </vs-col>
    <vs-col class="p-5" vs-type="flex" vs-w="11" vs-xs="11" vs-sm="5" vs-lg="6">
      <vx-card class="p-3">
        <h3>Total Blocks</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.blocksSum">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ p.blocks }} Total Blocks
            </router-link>
          </li>
        </ul>
      </vx-card>
      <vx-card class="p-3">
        <h3>Total Free Throws</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.ftmSum">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ p.ftm }} Total FTM
            </router-link>
          </li>
        </ul>
      </vx-card>
    </vs-col>
    <vs-col class="p-5" vs-type="flex" vs-w="11" vs-xs="11" vs-sm="5" vs-lg="6">
      <vx-card class="p-3">
        <h3>Average Points</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.pointsAvg">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ (p.points / p.games).toFixed(2) }} Points per game
            </router-link>
          </li>
        </ul>
      </vx-card>
      <vx-card class="p-3">
        <h3>Average Rebounds</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.reboundsAvg">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ (p.rebounds / p.games).toFixed(2) }} Rebounds per game
            </router-link>
          </li>
        </ul>
      </vx-card>
    </vs-col>
    <vs-col class="p-5" vs-type="flex" vs-w="11" vs-xs="11" vs-sm="5" vs-lg="6">
      <vx-card class="p-3">
        <h3>Average Assists</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.assistsAvg">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ (p.assists / p.games).toFixed(2) }} Assists per game
            </router-link>
          </li>
        </ul>
      </vx-card>
      <vx-card class="p-3">
        <h3>Average Steals</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.stealsAvg">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ (p.steals / p.games).toFixed(2) }} Steals per game
            </router-link>
          </li>
        </ul>
      </vx-card>
    </vs-col>
    <vs-col class="p-5" vs-type="flex" vs-w="11" vs-xs="11" vs-sm="5" vs-lg="6">
      <vx-card class="p-3">
        <h3>Average 2PT Field Goals</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.fgmAvg">
            {{ i + 1 }}.
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ (p.fgm / p.games).toFixed(2) }} FGM per game
            </router-link>
          </li>
        </ul>
      </vx-card>
      <vx-card class="p-3">
        <h3>Average 3PT Field Goals</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.fgm3Avg">
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ (p.fgm3 / p.games).toFixed(2) }} FGM3 per game
            </router-link>
          </li>
        </ul>
      </vx-card>
    </vs-col>
    <vs-col class="p-5" vs-type="flex" vs-w="11" vs-xs="11" vs-sm="5" vs-lg="6">
      <vx-card class="p-3">
        <h3>Average Blocks</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.blocksAvg">
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ (p.blocks / p.games).toFixed(2) }} Blocks per game
            </router-link>
          </li>
        </ul>
      </vx-card>
      <vx-card class="p-3">
        <h3>Average Free Throws</h3>
        <vs-divider class="my-3" />
        <ul>
          <li :key="i" v-for="(p, i) in analytics.ftmAvg">
            <router-link
              :to="{
                name: 'player',
                params: { id: p.player.id }
              }"
            >
              {{ p.player.firstname }} {{ p.player.lastname }} #{{
                p.player.jersey
              }}
              - {{ (p.ftm / p.games).toFixed(2) }} FTM per game
            </router-link>
          </li>
        </ul>
      </vx-card>
    </vs-col>
  </vs-row>
</template>
<script>
import UserRoles from "@/mixins/UserRoles";
import { mapActions } from "vuex";
export default {
  name: "analytics-listing",
  props: {
    league: {
      required: true
    }
  },
  mounted() {
    if (this.league) {
      this.loadLeagueAnalytics();
      this.loadLeagueDivisions();
    }
  },
  mixins: [UserRoles],
  data: () => ({
    analytics: [],
    divisions: [{ id: 0, name: "All Divisions" }],
    division: 0
  }),
  methods: {
    ...mapActions({
      getLeagueAnalytics: "league/getLeagueAnalytics",
      getLeagueDivisions: "league/getLeagueDivisions"
    }),
    async loadLeagueAnalytics(x) {
      this.$vs.loading();
      console.log("division", this.division);
      console.log("incoming data", x);
      const data = await this.getLeagueAnalytics({
        id: this.league.id,
        division: this.division
      });
      this.analytics = data;
      this.$vs.loading.close();
    },
    async loadLeagueDivisions() {
      this.$vs.loading();
      const { json } = await this.getLeagueDivisions({ id: this.league.id });
      console.log("json", json);
      this.divisions = json.reverse();
      this.divisions.push({ id: 0, name: "All Divisions" });
      this.$vs.loading.close();
    }
  }
};
</script>
